export default __webpack_public_path__ + "static/media/highstreet_banner.e101e209.png";